import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { GameService } from '../../../shared/services/game.service';
import { MessageService } from '../../../shared/services/message.service';

import { UrlConstants } from '../../../shared/constants/urlparams.constants';
import { StorageConstants } from '../../../shared/constants/storage.constants';

@Injectable()
export class GameFoundGuard implements CanActivate {
  constructor(private router: Router, private gameService: GameService, private messageService: MessageService) { }

  private async findGame(gameID: string): Promise<boolean | UrlTree> {
    await this.gameService.getGame(gameID).then(data => {
      sessionStorage.setItem(StorageConstants.GameID, data.GameID);
      return false;
    }).catch(() => {
      this.messageService.showError("Game bestaat niet!");
      return this.router.navigateByUrl('/');
    });

    return true;
  }

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.findGame(route.paramMap.get(UrlConstants.GameID));
  }
}
